export interface CreateProjectDto {
  name: string;
  description?: string;
}

export interface PositionDto {
  id: string;
  name: string;
  rate: number;
  projectId: string;
  createdAt: string;
}

export interface AddPositionDto {
  name: string;
  rate: number;
}

export interface EmployeeDto {
  id: string;
  name: string;
  positionName: string;
  positionId: string;
  department: string;
  unitManager: string | null;
}

export interface AddEmployeeDto {
  name: string;
  department: string;
  positionId: string;
  unitManager: string | null;
}

export interface EpicDto {
  id: string;
  name: string;
  description: string;
  projectId: string;
  createdAt: string;
}

export interface AddEpicDto {
  name: string;
  description?: string;
}

export interface EpicGroupDto {
  id: string;
  name: string;
  type: string;
  epics: string[];
  projectId: string;
  createdAt: string;
}

export interface AddEpicGroupDto {
  name: string;
  type: string;
  epics: string[];
}

export enum ColumnTypesEnum {
  Other = 'Other',
  Employee = 'Employee',
  Epic = 'Epic',
  LoggedTime = 'LoggedTime',
  CostType = 'CostType',
  Product = 'Product',
  Position = 'Position',
  Department = 'Department',
  EpicDescription = 'EpicDescription',
  UnitManager = 'UnitManager',
}

export interface ColumnDto {
  id: string;
  type: ColumnTypesEnum;
  name: string;
  sourceName: string;
  projectId: string;
  createdAt: string;
}

export interface AddColumnDto {
  type: string;
  name: string;
  sourceName: string;
}

export interface TableColumnDto {
  columnId: string;
  sequence: number;
}
export interface TableDto {
  id: string;
  type: string;
  name: string;
  columns: TableColumnDto[];
  projectId: string;
  createdAt: string;
}

export interface AddTableDto {
  type: string;
  name: string;
  columns: TableColumnDto[];
}

export interface SheetTableDto {
  tableId: string;
  sequence: number;
}

export interface SheetDto {
  id: string;
  name: string;
  epics: string[];
  tables: SheetTableDto[];
  projectId: string;
  createdAt: string;
}

export interface AddSheetDto {
  name: string;
  tables: SheetTableDto[];
  epics: string[];
}

export type CreateSheetDto = Omit<AddSheetDto, 'tables'> & { tables: string[] };

export interface ReportDto {
  id: string;
  name: string;
  reference: string;
  createdAt: string;
  isDataSource: boolean;
  metricsDate: string;
  totalCost: number;
  totalEmployees: number;
  totalHours: number;
  warnings: string[];
}

export interface ProjectDto {
  id: string;
  name: string;
  description: string;
  userId: string;
  createdAt: string;
  positions: PositionDto[];
  employees: EmployeeDto[];
  epics: EpicDto[];
  epicGroups: EpicGroupDto[];
  columns: ColumnDto[];
  tables: TableDto[];
  sheets: SheetDto[];
  reports: ReportDto[];
  isCompleted: boolean;
}

export interface ProjectsDto {
  items: ProjectDto[];
  total: number;
}

export interface GetMetricsDto {
  id: string;
  startDate?: string;
  endDate?: string;
  type: string;
}

export interface MetricDto {
  name: string;
  type: string;
  totalHours: number;
  totalCost: number;
  month: string;
}

export type GetSummaryMetricsDto = Omit<GetMetricsDto, 'type'>;

export interface SummaryMetricsDto {
  totalHours: number;
  totalCost: number;
  averageMonthCost: number;
  totalEmployees: number;
  costTypes: [
    {
      costType: string;
      totalCost: number;
    },
  ];
}
